import { ref } from 'vue';

const isLoading = ref(false);
const loadingMessage = ref('Cargando...');
const subMessage = ref('Por favor espere un momento...');

export const useLoading = () => {
  const setLoading = (value: boolean, message?: string, sub?: string) => {
    isLoading.value = value;
    if (message !== undefined) {
      loadingMessage.value = message;
    }
    if (sub !== undefined) {
      subMessage.value = sub;
    }
  };

  const showLoading = (message?: string, sub?: string) => {
    setLoading(true, message, sub);
  };

  const hideLoading = () => {
    setLoading(false);
  };

  return {
    isLoading,
    loadingMessage,
    subMessage,
    setLoading,
    showLoading,
    hideLoading,
  };
};

